/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_2_DescInputs */

const en_mk_sec_2_desc = /** @type {(inputs: Mk_Sec_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bs_ tokens live in ~/.config/bystep with mode 0600. Revoke any of them from Settings in one click.`)
};

const id_mk_sec_2_desc = /** @type {(inputs: Mk_Sec_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token bs_ tersimpan di ~/.config/bystep dengan mode 0600. Cabut kapan saja dari Pengaturan dengan satu klik.`)
};

/**
* | output |
* | --- |
* | "bs_ tokens live in ~/.config/bystep with mode 0600. Revoke any of them from Settings in one click." |
*
* @param {Mk_Sec_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_2_desc = /** @type {((inputs?: Mk_Sec_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_2_desc(inputs)
	return en_mk_sec_2_desc(inputs)
});